export default __webpack_public_path__ + "static/media/female_9.bd5be120.png";